import { CurrencyPipe } from '@angular/common';
import type { OnChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { I18nService } from '@recruitee/i18n';
import type { BillingPlan } from '@recruitee/products-types';
import type { Addon, PaymentInterval } from '@recruitee/subscription-types';
import { DividerComponent } from '@recruitee/user-interface';

import { getPaymentIntervalText } from '../../helpers/get-payment-interval-text';
import { getProductCost } from '../../helpers/get-product-cost';

@Component({
  selector: 'rt-subscription-cost',
  templateUrl: './subscription-cost.component.html',
  styleUrls: ['./subscription-cost.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DividerComponent, CurrencyPipe],
})
export class SubscriptionCostComponent implements OnChanges {
  @Input() public product: BillingPlan;
  @Input() public slots: number;
  @Input() public addons: Addon[];
  @Input() public interval: PaymentInterval;

  public totalCost: number;
  public intervalText: string;

  constructor(private i18n: I18nService) {}

  public ngOnChanges() {
    this.totalCost = getProductCost(this.product, this.slots, this.interval, this.addons);
    this.intervalText = getPaymentIntervalText(this.interval, this.i18n);
  }
}
